"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRemaningAccounts = exports.getTokenRateOverUsd = exports.getUsdRate = exports.getTokenRateOverRenec = exports.getRenecRate = exports.DENOMINATOR = void 0;
__exportStar(require("./offer"), exports);
const common_sdk_1 = require("@orca-so/common-sdk");
const web3_js_1 = require("@solana/web3.js");
exports.DENOMINATOR = 10000;
__exportStar(require("./kyc-cert"), exports);
const getRenecRate = (tokenInfo) => {
    const renecRate = common_sdk_1.DecimalUtil.fromU64(tokenInfo.renecRate, tokenInfo.tokenDecimal);
    return renecRate;
};
exports.getRenecRate = getRenecRate;
const getTokenRateOverRenec = (tokenRateInRenec) => {
    const renecRate = common_sdk_1.DecimalUtil.fromU64(tokenRateInRenec).div(web3_js_1.LAMPORTS_PER_SOL).pow(-1);
    return renecRate;
};
exports.getTokenRateOverRenec = getTokenRateOverRenec;
const getUsdRate = (usdRate) => {
    const renecRate = common_sdk_1.DecimalUtil.fromU64(usdRate, 9);
    return renecRate;
};
exports.getUsdRate = getUsdRate;
const getTokenRateOverUsd = (tokenRateInUsd) => {
    const renecRate = common_sdk_1.DecimalUtil.fromU64(tokenRateInUsd).div(web3_js_1.LAMPORTS_PER_SOL).pow(-1);
    return renecRate;
};
exports.getTokenRateOverUsd = getTokenRateOverUsd;
const getRemaningAccounts = (accounts) => {
    let remainingAccounts = [];
    for (let i = 0; i < accounts.length; i++) {
        remainingAccounts.push({
            isSigner: false,
            isWritable: true,
            pubkey: accounts[i],
        });
    }
    return remainingAccounts;
};
exports.getRemaningAccounts = getRemaningAccounts;
